import dayjs from 'dayjs';

export const getForecastingGraphData = yearMonths =>
  yearMonths?.map((month, index) => {
    const underContractDiff = month.underContract - month.actualRevenue;
    return {
      ...month,
      underContractDiff,
      name: dayjs().set('month', index).format('MMM, YYYY')
    };
  });

export const aggregateUnderContractFromProjects = (yearMonths, projects) => {
  if (!yearMonths || !projects) return yearMonths;

  const currentYear = dayjs().year();

  return yearMonths.map((monthData, index) => {
    const monthNumber = index + 1;
    const aggregatedRevenue = projects.reduce((sum, project) => {
      const summary = project.forecastedSummaries?.find(
        s => s.month === monthNumber && s.year === currentYear
      );
      return sum + (summary?.revenue || 0);
    }, 0);

    return {
      ...monthData,
      underContract: aggregatedRevenue
    };
  });
};

export const aggregatePipelineFromProjects = (
  yearMonths,
  selectedPipelineProjects,
  probabilities = {}
) => {
  if (!yearMonths || !selectedPipelineProjects) return yearMonths;

  const currentYear = dayjs().year();

  return yearMonths.map((monthData, index) => {
    const monthNumber = index + 1;
    const aggregatedRevenue = selectedPipelineProjects.reduce((sum, project) => {
      const summary = project.forecastedSummaries?.find(
        s => s.month === monthNumber && s.year === currentYear
      );
      const revenue = summary?.revenue || 0;
      const probability = (probabilities[project.id] ?? 60) / 100;
      return sum + revenue * probability;
    }, 0);

    return {
      ...monthData,
      pipeline: aggregatedRevenue
    };
  });
};
